export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'Página de Pagamento Seguro',
      description: 'Mantemos suas informações financeiras criptografadas com segurança',
      methodErrorTips: 'Desculpe, o país que você selecionou não é atualmente suportado. Por favor, selecione outro país e tente novamente.',
      recommendation: 'Recomendação',
      cardNumber: 'Número do Cartão',
      cardName: 'Nome no cartão',
      cvv: 'CVV',
      expiredDate: 'Data de Validade',
      billingInfo: ' Informações de Cobrança',
      country: 'País',
      state: 'Estado',
      firstName: 'Primeiro Nome',
      lastName: 'Sobrenome',
      document: 'Documento',
      city: 'Cidade',
      address: 'Endereço',
      streetNumber: 'Número da Rua',
      zipCode: 'Código Postal',
      email: 'Email',
      phone: 'Número de Telefone',
      pay: 'PAGAR',
      choosePaymentMethod: 'Escolha o método de pagamento',
      continue: 'Continuar',
      later: 'Mais tarde',
      returnToMerchant: 'Cancelar e Retornar ao Comerciante',
      resultToMerchant: 'Retornar ao comerciante',
      orderId: 'ID do Pedido',
      orderAmount: ' Valor do Pedido',
      billingDescriptor: 'Descrição da Cobrança',
      goodsName: 'Nome dos Produtos',
      timeLimit: 'Por favor, complete o pagamento dentro do prazo, caso contrário, a página será encerrada',
      otherPaymentMethods: 'Outros métodos de pagamento',
      close: 'Fechar',
      paymentErrorTitle: 'Pagamento falhou',
      paymentErrorTip: 'Seu pagamento não foi processado com sucesso. Por favor, tente novamente.',
      paymentFailed: 'O processo de pagamento falhou',
      continueShopping: 'Continuar Comprando',
      paymentSuccess: 'O Processo de Pagamento foi concluído com sucesso',
      paymentPending: 'Pagamento enviado, confirmando',
      correctDateTip: 'Por favor, insira uma data de validade válida',
      correctCardNumberTip: 'Por favor, insira um número de cartão válido',
      correctSecurityCodeTip: 'Por favor, insira um código de segurança válido',
      mobileMoneyOperator: 'Operador de dinheiro Móvel',
      bank: 'Banco',
      correctEmailAddressTip: 'Por favor, insira um endereço de e-mail válido',
      notSupportPaymentTip: 'O ambiente atual não suporta pagamento com {type}',
      addValidPaymentCard: 'Por favor, adicione um cartão de pagamento válido',
      timeLimitTip: 'Será cobrado 12 horas antes do término do período de teste (<span class="date">{date}</span>), e depois será renovado a cada <span class="date">{month}</span> meses por <span class="amount"> {amount} {currency}</span>, podendo ser cancelado a qualquer momento',
      product: 'Produto/Serviço',
      subscribeType: 'Tipo de Assinatura',
      renewCycle: 'Ciclo de Renovação',
      renewAmount: 'Valor da Renovação',
      subscribePay: 'Assinar e Pagar',
      readAgreement: "Leia e concorde com o <span class='protocol-link' style='color: #31a7da;'>Acordo de Renovação Automática</span>",
      depict: 'Descrição',
      copyQrCode: 'Copiar QR-Code',
      copySuccess: 'Copiado com sucesso',
      copyError: 'Falha ao copiar',
      refreshQrCode: 'Atualizar QR-Code'
    },
    subscribe: {
      yourSubscribe: 'Sua Assinatura',
      unsubscribeTip: 'Para cancelar, clique no botão [Cancelar Assinatura] na parte inferior da página.',
      renewTip: 'Cobrança em <span class="date">{date}</span> de <span class="amount"> {amount} {currency}</span>, pode ser cancelado a qualquer momento',
      unsubscribe: 'Cancelar Assinatura',
      autoRenew: 'Acordo de Renovação Automática',
      unsubscribeTipTwo: 'Se cancelar agora, você ainda poderá usar esta assinatura até <span class="date">{date}</span>.',
      emailVerifyTip: 'Verificação de E-mail',
      inputCodeTip: 'Por favor, insira o código de verificação',
      sendSuccessTip: 'Código de verificação enviado com sucesso',
      sendErrorTip: 'Falha ao enviar o código de verificação',
      unsubscribeSuccessTip: 'Assinatura cancelada com sucesso',
      unsubscribeErrorTip: 'Falha ao cancelar a assinatura',
      sendCodeTip: 'Reenviar em {code} segundos',
      sendEmailTip: 'Obter Código de Verificação',
      daily: 'A cada dia',
      weekly: 'A cada 7 dias',
      monthly: 'A cada 30 dias',
      quarterly: 'A cada 90 dias',
      semiAnnually: 'A cada 180 dias',
      annually: 'A cada 365 dias',
      regularRenewal: 'Renovação Regular',
      oneTime: 'Uma vez',
      inputNumberTip: 'Por favor, insira apenas números',
      eachCalendarMonth: 'A cada mês civil'
    },
    common: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      uploadImgErrorTip: 'Só é permitido fazer upload de imagens',
      inputMessageTip: 'Por favor, preencha o conteúdo',
      sendSuccessTip: 'Enviado com sucesso',
      sendErrorTip: 'Falha no envio',
      inputPlaceholder: 'Por favor, insira {field}',
      selectPlaceholder: 'Por favor, selecione {field}',
      correctFormat: 'Por favor, insira o formato correto, por exemplo: {example}'
    }
  }
}
